// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3k9P6","footer":"ModalError_footer__2EwlP"};